import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import { Provider } from 'react-redux'
import { applyMiddleware, createStore } from 'redux'
import getCombinedReducers from './reducers'
import thunk from 'redux-thunk'

const store = createStore(
  getCombinedReducers(),
  {},
  composeWithDevTools(applyMiddleware(thunk))
)

export class ReduxStore extends Component {
  render () {
    return (
      <Provider store={store}>
        {this.props.children}
      </Provider>
    )
  }
}

ReduxStore.propTypes = {
  children: PropTypes.any
}
